import type { ReactNode } from "react";
import { Eye } from "lucide-react";
import { useViewerCapabilities } from "@/lib/capabilities";

/**
 * Wraps pages that only start or manage work (create flows, template management). Reviewers reach
 * them only by URL, so they get an explanation instead of a form the server would refuse.
 */
export function EditAccessGate({ children }: { children: ReactNode }) {
  const capabilities = useViewerCapabilities();
  if (!capabilities) return null;
  if (capabilities.canEditWork) return children;

  return (
    <section
      aria-labelledby="view-only-page-title"
      className="mx-auto flex w-full max-w-md flex-col items-center rounded-lg border-2 border-dashed border-border bg-card/50 p-6 text-center sm:p-10"
    >
      <div className="flex size-16 items-center justify-center rounded-xl border-2 border-muted bg-muted/50">
        <Eye className="size-8 text-muted-foreground" aria-hidden="true" />
      </div>
      <h1 id="view-only-page-title" className="mt-5 text-lg font-bold text-foreground">
        You have view-only access
      </h1>
      <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
        As a reviewer you can view the projects you're added to and download completed exports. To
        start new work, ask a company admin to make you a member.
      </p>
    </section>
  );
}
